import React, { useState } from 'react'



const Membership = () => {

    

   
    return (
        <main>

            <p className='profile-title'> Medlemskaber </p>

        </main>
    )
}

export default Membership